<template>
  <b-container class="loading" />
</template>

<script>
export default {
  name: 'Loading',
};
</script>
